/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetOption, WatchOption } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import Options from 'core/store/ducks/pi/options';
import translate from 'services/i18n/translate';

function setTrailerOptionTitle(rawOptions: WatchOption[]): WatchOption[] {
  return rawOptions.map((op) => {
    const title = translate['buttons.watch.trailer'];
    return { ...op, title };
  });
}

export default function* getTrailerOptions(clones: Asset[]): SagaIterator<AssetOption[]> {
  try {
    // get all options
    const watchOptions: WatchOption[] = yield call(Options.getTrailerOptions, clones);

    // get first option
    // note: because the current specs are considering only one trailer option
    const firstOption = watchOptions.length ? [watchOptions[0]] : [];

    // adapt options for the App UI
    return setTrailerOptionTitle(firstOption);
  } catch {
    return [];
  }
}
